import { head } from 'ramda'
import React from 'react'

import { useMultiSelectState } from '../../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import { useTriggerCalls } from '../_load/TriggerCallsLoader'
import { useTriggerCallsActions } from '../../_actions/triggerCallsActions'
import MultiSelectMenu from '../../../../packages/kiti/components/multiSelect/MultiSelectMenu'

const MultiRowsActions = () => {
  const triggerCalls = useTriggerCalls()
  const { selecteds, getSelectedData } = useMultiSelectState()
  const selectedTriggerCalls = getSelectedData(triggerCalls)
  const [menuOptions, loading] = useTriggerCallsActions(head(selectedTriggerCalls), selecteds)

  return <MultiSelectMenu loading={loading} options={menuOptions} />
}

export default MultiRowsActions
